// extracted by mini-css-extract-plugin
export var footer = "_9y-0";
export var footerButton = "_9y-6";
export var imagePreviewContainer = "_9y-1";
export var imagePreviewDeleteButton = "_9y-3";
export var imagePreviewItem = "_9y-2";
export var messageInputForm = "_9y-4";
export var quillEditor = "_9y-5";